export default "__VITE_ASSET__BLAwKqUr__"